<template>
  <transition name="snackbar-fade">
    <v-card 
      v-if="show" 
      class="custom-snackbar" 
      :class="[snackbarTypeClass, {'clickable': clickToClose}]" 
      dark 
      elevation="2"
      @click="handleSnackbarClick"
    >
      <div class="snackbar-content">
    
        <div class="snackbar-text">
          <div class="snackbar-title">{{ title }}</div>
          <div class="snackbar-message" v-if="text">{{ text }}</div>
        </div>
        
      </div>
      <div class="snackbar-progress" v-if="timeout > 0 && show && color != 'error'">
        <div 
          class="snackbar-progress-bar" 
          :style="{ 'animation-duration': timeout + 'ms' }"
        ></div>
      </div>
    </v-card>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      title: '',
      text: '',
      color: 'success',
      timeout: 5000,
      showIcon: true,
      showCloseButton: true,
      clickToClose: true
    }
  },
  computed: {
    snackbarTypeClass() {
      return `snackbar-${this.color}`;
    },
  },
  methods: {
    notify(options) {
      // Reset timer if already showing
      if (this.show && this._timer) {
        clearTimeout(this._timer);
      }
      
      this.title = options.title || this.getDefaultTitle(options.type || 'success');
      this.text = options.text || null;
      this.color = options.type || 'success';
      this.timeout = options.timeout !== undefined ? options.timeout : 5000;
      this.showIcon = options.showIcon !== undefined ? options.showIcon : true;
      this.showCloseButton = options.showCloseButton !== undefined ? options.showCloseButton : true;
      this.clickToClose = options.clickToClose !== undefined ? options.clickToClose : true;
      
      this.show = true;
      
      // Auto-hide if timeout > 0 and type is not error
      if (this.timeout > 0 && this.color !== 'error') {
        this._timer = setTimeout(() => {
          this.show = false;
        }, this.timeout);
      }
    },
    
    getDefaultTitle(type) {
      switch(type) {
        case 'success': return 'Éxito';
        case 'error': return 'Error';
        case 'warning': return 'Advertencia';
        case 'info': return 'Información';
        default: return 'Notificación';
      }
    },

    closeSnackbar() {
      this.show = false;
      if (this._timer) {
        clearTimeout(this._timer);
      }
    },

    handleSnackbarClick() {
      if (this.clickToClose) {
        this.closeSnackbar();
      }
    }
  },
  
  beforeDestroy() {
    if (this._timer) {
      clearTimeout(this._timer);
    }
  }
}
</script>

<style scoped>
.custom-snackbar {
  position: fixed;
  top: 16px;
  right: 16px;
  min-width: 320px;
  max-width: 420px;
  border-radius: 8px;
  overflow: hidden;
  z-index: 9999;
}

.custom-snackbar.clickable {
  cursor: pointer;
}


.snackbar-content {
  display: flex;
  align-items: flex-start;
  padding: 16px;
}

.snackbar-icon {
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.snackbar-text {
  flex: 1;
}

.snackbar-title {
  font-weight: 600;
  margin-bottom: 4px;
  font-size: 1rem;
}

.snackbar-message {
  font-size: 0.875rem;
  opacity: 0.8;
}

.snackbar-actions {
  margin-left: 12px;
}

/* Type-specific styles */
.snackbar-success {
  border-left: 4px solid #4CAF50;
}
.snackbar-success .snackbar-icon {
  color: #4CAF50;
}

.snackbar-error {
  border-left: 4px solid #F44336;
}
.snackbar-error .snackbar-icon {
  color: #F44336;
}

.snackbar-warning {
  border-left: 4px solid #FF9800;
}
.snackbar-warning .snackbar-icon {
  color: #FF9800;
}

.snackbar-info {
  border-left: 4px solid #2196F3;
}
.snackbar-info .snackbar-icon {
  color: #2196F3;
}

/* Progress bar */
.snackbar-progress {
  height: 3px;
  width: 100%;
  background: rgba(0,0,0,0.1);
}

.snackbar-progress-bar {
  height: 100%;
  width: 100%;
  transform-origin: left center;
  animation: progress-shrink linear forwards;
}

@keyframes progress-shrink {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.snackbar-success .snackbar-progress-bar {
  background: #4CAF50;
}
.snackbar-error .snackbar-progress-bar {
  background: #F44336;
}
.snackbar-warning .snackbar-progress-bar {
  background: #FF9800;
}
.snackbar-info .snackbar-progress-bar {
  background: #2196F3;
}

/* Transition animations */
.snackbar-fade-enter-active, .snackbar-fade-leave-active {
  transition: all 0.3s ease;
}
.snackbar-fade-enter, .snackbar-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
